import type { MenuProps } from "antd";
import type { NavigateFunction } from "react-router-dom";
import {
  IdcardOutlined,
  LogoutOutlined,
  ShoppingOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import { globalModel } from "../../global/GlobalModel";

export type ShellUserDropdownMenuOpts = {
  navigate: NavigateFunction;
  /** 仍可用于后续扩展（如按空间维度提示）；「我的订单」入口始终展示 */
  ordersSpaceId?: string | null;
  /** 「与我相关的空间」一律弹框，由 Provider 打开 */
  onFollowsClick: () => void;
  /** 「我的订单」一律弹框 */
  onOrdersClick: () => void;
};

/** 全站统一的顶栏／空间顶栏头像下拉菜单定义 */
export function shellUserDropdownMenu(
  opts: ShellUserDropdownMenuOpts
): MenuProps {
  const {
    navigate,
    onFollowsClick,
    onOrdersClick,
  } = opts;

  const items: MenuProps["items"] = [
    { key: "profile", label: "个人资料", icon: <IdcardOutlined /> },
    { key: "switch", label: "我的关注", icon: <UnorderedListOutlined /> },
    {
      key: "orders",
      label: "我的订单",
      icon: <ShoppingOutlined />,
    },
  ];
  items.push(
    { type: "divider" },
    {
      key: "logout",
      label: "退出登录",
      icon: <LogoutOutlined />,
      danger: true,
    }
  );

  return {
    items,
    onClick: ({ key }) => {
      if (key === "profile") {
        globalModel.openProfileEditor();
        return;
      }
      if (key === "switch") {
        onFollowsClick();
        return;
      }
      if (key === "orders") {
        onOrdersClick();
        return;
      }
      if (key === "logout") {
        void globalModel.logout().then(() => navigate("/"));
      }
    },
  };
}
